import React from 'react'

/**
 * NOTE: we are using Pageclip here!
 */
class ContactFormComponent extends React.Component {
  constructor() {
    super()
    this.state = { messageWasSent: false }
    this.closeAlert = this.closeAlert.bind(this)  // bind event-handler
  }

  componentDidMount() {
    const self = this
    var form = document.querySelector('.pageclip-form')
    Pageclip.form(form, {
      // onSubmit: function (event) { },
      onResponse: function (error, response) {
        if (!error) {
          // window.location.href = '/danke-fuer-ihre-nachricht'
          self.setState(prevState => ({
            messageWasSent: true,
          }))
        }
        if (error) {
          alert('Es ist leider ein Fehler aufgetreten. Bitte rufen Sie uns an und sagen uns, dass wir unsere Webseite besser testen sollen! Sie erreichen uns unter 02175-6688760. Vielen Dank!')
        }
      },
      successTemplate: '<span>Vielen Dank für Ihre Nachricht!</span>'
    })
  }

  closeAlert(e) {
    this.setState(prevState => ({
      messageWasSent: !prevState.messageWasSent
    }))
  }

  render() {
    const { language } = this.props
    let nameText = 'Ihr Name'
    let phoneText = 'Ihre Telefonnummer'
    let emailText = 'Ihre E-Mail-Adresse'
    let messageText = 'Ihre Nachricht'
    let ctaText = 'Jetzt absenden'
    let thanksText = 'Vielen Dank für Ihre Nachricht!'
    let hearFromUsText = 'Wir werden Sie schnellstmöglich kontaktieren.'
    if (language==='en') {
      nameText = 'Your name'
      phoneText = 'Your phone number'
      emailText = 'Your email'
      messageText = 'Your message to us'
      ctaText = 'Send message now'
      thanksText = 'Thank you for your message!'
      hearFromUsText = `We'll get in touch asap.`
    }
    if (!this.state.messageWasSent) {
      return (
        <form action="https://send.pageclip.co/Xu4fzz8VZ2hqLIz4JZlRcyPVoW4BZrJo" className="pageclip-form" method="post">
          <div className="form-group">
            <input id="inputName" type="string" className="form-control" name="Name" placeholder={nameText} required/>
          </div>
          <div className="form-group">
            <input id="inputPhone" type="phone" className="form-control" name="Telefonnummer" placeholder={phoneText} required/>
          </div>
          <div className="form-group">
            <input id="inputEmail" type="email" className="form-control" name="Email" placeholder={emailText} required/>
          </div>
          <div className="form-group">
            <textarea id="inputMessage" className="form-control" name="Nachricht" rows="10" cols="50" placeholder={messageText} required></textarea>
          </div>
          <button type="submit" className="btn btn-primary btn-lg btn-block pageclip-form__submit">
            {ctaText} <i className="fab fa-telegram-plane"></i>
          </button>
        </form>
      )
    } else {
      return (
        <div className="alert alert-success alert-dismissible" role="alert">
          <button onClick={this.closeAlert} type="button" className="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h1><i className="fas fa-check-circle"></i></h1>
          <h1>{thanksText}</h1>
          <p>{hearFromUsText}</p>
        </div>
      )
    }
  }
}

export default ContactFormComponent



// WEBPACK FOOTER //
// ./src/components/ContactFormComponent/index.js